import { useMemo } from "react";
import { Provider } from "react-redux";
import { Navigate, Outlet, Routes } from "react-router";
import { BrowserRouter, Route } from "react-router-dom";
import AddOns from "./AddOns";
import RecruiterAi from "./RecruiterAi";

const Layout = () => <Outlet />;

const AddOnsApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  return (
    <Provider store={store}>
      <BrowserRouter basename="/add_ons">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<AddOns />} />
            <Route path="recruiter_ai" element={<RecruiterAi />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default AddOnsApp;
